import keyMirror from 'utils/keyMirror';

/**
 * @constant {Object} LookupConstants
 * @memberof Application
 */
export const LookupConstants = keyMirror({
  GET_LOAN_PURPOSES: undefined,
});
